import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Typography
} from "@material-ui/core";
import useStyles from "./../styles";
import React, { useState } from "react";
import { DiscountWriteModel } from "../../../models/Discount";
import { getDiscountType } from "../utils";
import { DiscountType } from "../types";
import { QrCode, ShoppingCartCheckout } from "@mui/icons-material";
import { Cake, CalendarToday, DateRange } from "@material-ui/icons";
import { useTheme } from "@material-ui/core/styles";

interface Props {
  onSelect?: Function;
  discountTypes: ReadonlyArray<DiscountType>;
  discount: DiscountWriteModel;
  disabled?: boolean;
}

export const DiscountTypeSelector = ({
  onSelect,
  discountTypes,
  discount,
  disabled
}: Props) => {
  const classes = useStyles();
  const theme = useTheme();

  const getInitialDiscountType = (
    discount: DiscountWriteModel,
    discountTypes: ReadonlyArray<DiscountType>
  ) => {
    if (discount.type === undefined || discount.type === null) {
      return getDiscountType(1, discountTypes);
    }
    return getDiscountType(discount.type, discountTypes);
  };

  const initDiscType = getInitialDiscountType(discount, discountTypes);
  const [value, setValue] = useState<number>(
    initDiscType ? initDiscType.id : discountTypes[1].id
  );

  const onChange = (value: any) => {
    setValue(value);
    if (onSelect) {
      onSelect(value);
    }
  };

  const getIcon = (val: number) => {
    switch (val) {
      case 0:
        return (
          <QrCode
            fontSize={"large"}
            style={{
              color:
                val === value
                  ? theme.palette.primary.dark
                  : theme.palette.text.secondary
            }}
          />
        );
      case 1:
        return (
          <ShoppingCartCheckout
            fontSize={"large"}
            style={{
              color:
                val === value
                  ? theme.palette.primary.dark
                  : theme.palette.text.secondary
            }}
          />
        );
      case 2:
        return (
          <CalendarToday
            fontSize={"large"}
            style={{
              color:
                val === value
                  ? theme.palette.primary.dark
                  : theme.palette.text.secondary
            }}
          />
        );
      case 3:
        return (
          <DateRange
            fontSize={"large"}
            style={{
              color:
                val === value
                  ? theme.palette.primary.dark
                  : theme.palette.text.secondary
            }}
          />
        );
      case 4:
        return (
          <Cake
            fontSize={"large"}
            style={{
              color:
                val === value
                  ? theme.palette.primary.dark
                  : theme.palette.text.secondary
            }}
          />
        );
    }
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignContent={"center"}
      alignItems={"center"}
    >
      <Box sx={{ width: "70%" }}>
        <List>
          {discountTypes.map(dt => {
            return (
              <ListItem
                onClick={() => onChange(dt.id)}
                style={{
                  cursor: "pointer",
                  color:
                    dt.id === value
                      ? theme.palette.primary.dark
                      : theme.palette.text.primary
                }}
              >
                <ListItemIcon>{getIcon(dt.id)}</ListItemIcon>
                <ListItemText primary={dt.label} secondary={dt.description} />
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Box>
  );
};
